var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMobility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-848-22H302v754H-848z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    transform: "translate(20.768 24.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.289 34.833a2.02 2.02 0 0 0 3.92-.979L20.142 1.531A2.02 2.02 0 0 0 18.182 0H10.1a2.02 2.02 0 0 0 0 4.04h6.503l7.685 30.793zM47.674 48.485h14.952a2.02 2.02 0 1 0 0-4.04H47.674a2.02 2.02 0 1 0 0 4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.404 28.283h25.101c5.579 0 10.101 4.522 10.101 10.1v28.284a2.02 2.02 0 1 0 4.04 0V38.384c0-7.81-6.33-14.142-14.14-14.142H25.403a2.02 2.02 0 0 0 0 4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.204 49.243a2.02 2.02 0 1 0-3.155 2.524L77.21 71.97a2.02 2.02 0 0 0 2.481.545l8.081-4.04a2.02 2.02 0 0 0-1.807-3.614l-6.62 3.31-15.141-18.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M62.626 84.848c-5.578 0-10.1-4.522-10.1-10.1 0-5.58 4.522-10.102 10.1-10.102 5.579 0 10.101 4.523 10.101 10.101 0 5.58-4.522 10.101-10.1 10.101zm0-4.04a6.06 6.06 0 1 0 0-12.121 6.06 6.06 0 0 0 0 12.121z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.626,
    cy: 74.747,
    r: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M26.263 84.848C11.758 84.848 0 73.09 0 58.586 0 44.08 11.758 32.323 26.263 32.323c14.504 0 26.262 11.758 26.262 26.263 0 14.504-11.758 26.262-26.262 26.262zm0-4.04c12.273 0 22.222-9.95 22.222-22.222 0-12.273-9.95-22.222-22.222-22.222-12.273 0-22.223 9.949-22.223 22.222 0 12.273 9.95 22.222 22.223 22.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M18.436 60.606H2.02a2.02 2.02 0 1 1 0-4.04h16.416a8.095 8.095 0 0 0-.254 2.02c0 .697.088 1.374.254 2.02zm2.165-7.786l-8.21-14.219a2.02 2.02 0 1 1 3.5-2.02l8.208 14.217a8.072 8.072 0 0 0-3.498 2.022zm7.825-2.022l8.208-14.217a2.02 2.02 0 0 1 3.5 2.02l-8.21 14.219a8.072 8.072 0 0 0-3.498-2.022zm5.663 5.768h16.416a2.02 2.02 0 1 1 0 4.04H34.09a8.095 8.095 0 0 0 .254-2.02c0-.698-.088-1.375-.254-2.02zm-2.165 7.786l8.21 14.218a2.02 2.02 0 1 1-3.5 2.02l-8.208-14.216a8.072 8.072 0 0 0 3.498-2.022zM24.1 66.374L15.891 80.59a2.02 2.02 0 0 1-3.5-2.02l8.21-14.22a8.072 8.072 0 0 0 3.498 2.023zM26.263 64.646a6.06 6.06 0 1 1 0-12.12 6.06 6.06 0 0 1 0 12.12zm0-4.04a2.02 2.02 0 1 0 0-4.04 2.02 2.02 0 0 0 0 4.04z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMobility);
export default __webpack_public_path__ + "static/media/ico-mobility.0398873363b337590506068e8c7f0c2a.svg";
export { ForwardRef as ReactComponent };